<div class="container">
  <div class="pt-10">

    <ion-row class="center-content">
      <ion-col size="12">
        <ion-row class="borderbottomForTab" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
          <!-- <ion-col size-sm="10" size-md="9" size-lg="2" size-xs="10" class="mb-10">
            <div>

              <mat-form-field class="w-100 mat-height40 mat-input-style float-right">
                <mat-select placeholder="Select">
                  <mat-option>
                  
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </ion-col>

          </ion-row> -->
          <!-- <div *ngIf="setupNotCompleted" style="color: red;">
            Not Completed Set Up
          </div> -->
          <ion-col size="6" size-md="3" size-lg="2">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYear"
                (selectionChange)="onClickYtdYear($event,'Year','all')">
                <mat-option [value]="item.year"
                  *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="6" size-md="3" size-lg="2">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="fromDate"
                (selectionChange)="onClickYtdYear($event,'Month','all')">
                <mat-option [value]="item.number"
                  *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
      </ion-col>

    </ion-row>
  </div>

  <ion-row *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
    <ion-col size="6" size-md="4" size-lg="3" *ngFor="let item of counterModule">
      <ion-row class="cardBox cp w-100 h-100 ion-align-items-center" (click)="onTabClick(item)">
        <ion-col size="12" size-md="2" class="ion-text-center">
          <img class="counterIcon" src="{{item.moduleActiveIcon}}" [ngStyle]="{'background': item?.background ? item.background : 'red'  }">
        </ion-col>
        <ion-col size="12" size-md="9">
          <div class="font_semibold fs-11 black_color">{{item.ModuleName}}</div>
          <div class="font_bold mt-10 black_color" [ngStyle]="{'color': item?.color ? item.color : 'red' }">{{item.totalCount}}</div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="ion-justify-content-start ion-align-items-start"   *ngIf="!['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(loggedInUserRole)">
    <ion-col size="auto" size-sm="6" size-md="4" size-lg="3" size-xs="6" *ngFor="let item of counterModuleForHODAndManager">
      <ion-row class="cardBox text-left"  (click)="onTabClick(item)">
        <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
          <img class="counterIcon" src="{{item.moduleActiveIcon}}"
              [ngStyle]="{'background': item?.background ? item.background : 'red' }">
      </ion-col>
        <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
          <div class="font_semibold fs-11 black_color">
            {{ item.ModuleName }}
          </div>
          <div class="font_bold mt-10 black_color ml-30" [ngStyle]="{'color': item?.color ? item.color : 'red', }">
            {{ item.totalCount }}
          </div>
        </ion-col> 

        
        <!-- <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
          <img class="counterIcon" src="{{item.moduleActiveIcon}}"
              [ngStyle]="{'background': item?.background ? item.background : 'red' }">
      </ion-col>
      <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
        
          <div class="font_semibold fs-11 black_color">
              {{item.ModuleName}}
          </div>
          <div class="font_bold mt-10 black_color ml-30"
              [ngStyle]="{'color': item?.color ? item.color : 'red' }">
              {{item.totalCount}}</div>
      </ion-col> -->
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" size-md="6" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-15 ">Emp. appl. filled by candidate vs sent by HR</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row> -->
              <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3"> -->
                <span (click)="switchelcmTypeGraph1('bar')">
                  <img *ngIf="isElcmTypeIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col> -->
              <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3"> -->
                <span (click)="switchElcmTypeTable1()">
                  <img *ngIf="!isElcmTypetable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col> -->
              <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3"> -->
                <span (click)="switchelcmTypeGraph1('line')">
                  <img *ngIf="isElcmTypeIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col> -->
              <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="cp" > -->
                <img  (click)="downloadChartAsPDF('Emp. appl. filled by candidate vs sent by HR')" src="././assets/icon/downloadIcon.svg" class="cp">
              <!-- </ion-col> -->
            <!-- </ion-row> -->
             </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYeargraph1"
                (selectionChange)="onClickYtdYear($event,'Year','graph1')">
                <mat-option [value]="item.year"
                  *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="fromDate1"
                (selectionChange)="onClickYtdYear($event,'Month','graph1')">
                <mat-option [value]="item.number"
                  *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

        </ion-row>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" *ngIf="isElcmTypetable">
            <div id="table-scroll">
              <table id="graph1-table-data">
                <tr>
                  <th>Application Send</th>
                  <th>Application Field</th>
                  <!-- <th>Till Date YTD Wise</th> -->
                </tr>
          
                <tr>
                  <td>{{firstGraphTableData.CandidateCount}}</td>
                  <td>{{firstGraphTableData.FilledCandidateCount}}</td>
                
                </tr>
              </table>
            </div>
          </ion-col>


          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" *ngIf="!isElcmTypetable">
            <!-- <div id="chart-bar-quarterly" style="width: 100%; height: 400px;"></div>
              -->
              <div [ngClass]="{'dispNone' : firstGraphTableData}"id="chart-bar-application" 
              style="width: 100%; height: 400px;"></div>
          </ion-col>


        </ion-row>
      </div>
    </ion-col>

    <!--------------------------------------- new Added Graph ----------------------------------------------------->
    <ion-col size="12" size-md="6" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-15 ">Emp. appl. filled by HR vs filled by candidate</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row>
              <ion-col size="3"> -->
                <span (click)="switchelcmTypeGraphFiledHr('bar')">
                  <img *ngIf="isElcmTypeIconFieldHr != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIconFieldHr == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchElcmTypeTableFieldHr()">
                  <img *ngIf="!isElcmTypetableFieldHr" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetableFieldHr" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchelcmTypeGraphFiledHr('line')">
                  <img *ngIf="isElcmTypeIconFieldHr != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIconFieldHr == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3" class="cp"> -->
                <img (click)="downloadChartAsPDF('Emp. appl. filled by HR vs filled by candidate')" src="././assets/icon/downloadIcon.svg" class="cp">
              <!-- </ion-col>
            </ion-row> -->
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <!-- <ion-col size="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Dept" (selectionChange)="selectdepartMentForHrField($event)">
                <mat-option [value]="null">Select All</mat-option>
                <mat-option *ngFor="let item of departmentData"
                  [value]="item.xAxisValueData">{{item.xAxisValueData}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col> -->
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYeargraph2"
                (selectionChange)="onClickYtdYear($event,'Year','graph2')">
                <mat-option [value]="item.year"
                  *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="fromDate2"
                (selectionChange)="onClickYtdYear($event,'Month','graph2')">
                <mat-option [value]="item.number"
                  *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" *ngIf="isElcmTypetableFieldHr">
            <div id="table-scroll">
              <table id="graph2-table-data">
                <thead>
                  <tr>
                    <th >Filled HR Count</th>
                    <th >Filled Candidate Count</th>
                  </tr>
                </thead>
                <tbody>
                
                  <tr>
                    <td class="fs-14 fs_12ForMobile font_semibold">{{ hrFieldcandidateData.FilledHRCount }}</td>
                    <td class="fs-14 fs_12ForMobile font_semibold">{{ hrFieldcandidateData.FilledCandidateCount }}</td>
                  </tr>
                </tbody>
              </table>
              
            </div>
          </ion-col>

          <!-- <ion-col size="12">
            
            <div [ngClass]="{'dispNone' : departmentData}"  id="filed-hr-chart"
            style="width: 550px; height: 400px;"></div>
          </ion-col> -->
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" *ngIf="!isElcmTypetableFieldHr">
            <!-- <div id="chart-bar-quarterly" style="width: 100%; height: 400px;"></div>
              -->
              <div [ngClass]="{'dispNone' : firstGraphTableData}" id="filed-hr-chart"
              style="width: 100%; height: 400px;"></div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>

    <!-- SECOND GRAPH -->
    <ion-col size="12" size-md="6" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-15 ">Offer letter sent by HR vs. emp. appl. filled by HR</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row>
              <ion-col size="3"> -->
                <span (click)="switchelcmTypeGraph2('bar')">
                  <img *ngIf="isElcmTypeIcon2 != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon2 == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchElcmTypeTable2()">
                  <img *ngIf="!isElcmTypetable2" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetable2" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchelcmTypeGraph2('line')">
                  <img *ngIf="isElcmTypeIcon2 != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon2 == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3" class="cp"> -->
                <img (click)="downloadChartAsPDF('Offer letter sent by HR vs. emp. appl. filled by HR')"src="././assets/icon/downloadIcon.svg">
              <!-- </ion-col> -->
            <!-- </ion-row> -->
             </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Dept" (selectionChange)="selectdepartMent($event)">
                <mat-option [value]="null">Select All</mat-option>
                <mat-option *ngFor="let item of departmentData"
                  [value]="item.xAxisValueData">{{item.xAxisValueData}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYeargraph3"
                (selectionChange)="onClickYtdYear($event,'Year','graph3')">
                <mat-option [value]="item.year"
                  *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="fromDate3"
                (selectionChange)="onClickYtdYear($event,'Month','graph3')">
                <mat-option [value]="item.number"
                  *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" *ngIf="isElcmTypetable2">
            <div id="table-scroll">
              <table id="graph3-table-data">
                <tr>
                  <th>Department</th>
                  <th>Send Offer Letter Count
                  </th>
                  <th>
                    HR Filled Count</th>
                </tr>
                <tr *ngFor="let item of departmentData">
                  <td class="fs-14 fs_12ForMobile font_semibold">{{item.xAxisValueData}}</td>
                  <td>{{item.seriesValueOneData}}</td>
                  <td>{{item.seriesValueTwoData}}</td>
                </tr>
              </table>
            </div>
          </ion-col>

          <ion-col size="12"  *ngIf="!isElcmTypetable2">
            <!-- <div id="offer-letter-chart" style="width: 100%; height: 400px;"></div> -->
            <div [ngClass]="{'dispNone' : departmentData}"  id="offer-letter-chart"
            style="width: 100%; height: 400px;"></div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>

    <ion-col size="12" size-md="6" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-15 ">Cand. joined and appointment letter issued vs offer letter sent by HR</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row>
              <ion-col size="3"> -->
                <span (click)="switchElcmTypeGraph3('bar')">
                  <img *ngIf="isElcmTypeIcon3 != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon3 == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchElcmTypeTable3()">
                  <img *ngIf="!isElcmTypetable3" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetable3" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3"> -->
                <span (click)="switchElcmTypeGraph3('line')">
                  <img *ngIf="isElcmTypeIcon3 != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon3 == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="3" class="cp"> -->
                <img (click)="downloadChartAsPDF('Cand. joined and appointment letter issued vs offer letter sent by HR')"src="././assets/icon/downloadIcon.svg">
              <!-- </ion-col>
            </ion-row> -->
            </div>
          </ion-col>
        </ion-row>
    
        <ion-row>
        
          <ion-col size="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Dept" (selectionChange)="selectDepartment3($event)">
                <mat-option [value]="null">Select All</mat-option>
                <mat-option *ngFor="let item of departmentDataForThirdGraphDD"
                  [value]="item.xAxisValueData">{{item.xAxisValueData}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYeargraph4"
                (selectionChange)="onClickYtdYear($event,'Year','graph4')">
                <mat-option [value]="item.year"
                  *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="fromDate4"
                (selectionChange)="onClickYtdYear($event,'Month','graph4')">
                <mat-option [value]="item.number"
                  *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
    
        <ion-row>
          <ion-col size="12" *ngIf="isElcmTypetable3">
            <div id="table-scroll">
              <table id="graph4-table-data">
                <tr>
                  <th>Department</th>
                  <th>Send Offer Letter Count</th>
                  <th>Approved Appointment Letter</th>
                </tr>
                <tr *ngFor="let item of tableData">
                  <td class="fs-14 fs_12ForMobile font_semibold">{{item.xAxisValueData}}</td>
                  <td>{{item.seriesValueOneData}}</td>
                  <td>{{item.seriesValueTwoData}}</td>
                </tr>
              </table>
            </div>
          </ion-col>
    
          <ion-col size="12" *ngIf="!isElcmTypetable3">
            <!-- <div id="third-elcm-chart" style="width: 100%; height: 400px;"></div>
              -->
              <div [ngClass]="{'dispNone' : tableData}" id="third-elcm-chart" 
              style="width: 100%; height: 400px;"></div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
    <!-- <ion-col size="12" size-md="6">
    </ion-col> -->

    <ion-col size="12" *ngIf="CheckArrayLength1 !==0 ||CheckArrayLength2!==0">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-16 fs_14ForMobile ">Probation vs extension vs confirmation</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row class="icon-group">
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeGraph4('bar')">
                  <img *ngIf="isElcmTypeIcon4 != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon4 == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeTable4()">
                  <img *ngIf="!isElcmTypetable4" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetable4" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeGraph4('line')">
                  <img *ngIf="isElcmTypeIcon4 != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIcon4 == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto" class="cp"> -->
                <img   (click)="downloadChartAsPDF('Probation vs extension vs confirmation')"src="././assets/icon/downloadIcon.svg">
              <!-- </ion-col>
            </ion-row> -->
            </div>
          </ion-col>
        </ion-row>
        
    
        <ion-row>
       
          <ion-col size="12" size-md="4" size-lg="2"   *ngIf="['HR Admin','Super Admin','PHI Admin','MD'].includes(loggedInUserRole)">
            
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Dept" (selectionChange)="selectDepartment4($event)">
                <mat-option [value]="null">Select All</mat-option>
                <mat-option *ngFor="let item of commanDataForProbation"
                  [value]="item">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
          <ion-col size="12" size-md="4" size-lg="2"   *ngIf="!['HR Admin','Super Admin','PHI Admin','MD'].includes(loggedInUserRole)">
            
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Dept" (selectionChange)="selectDepartment4($event)">
                <mat-option [value]="null">Select All</mat-option>
                <mat-option *ngFor="let item of departmentDataForFourthGraphDD"
                  [value]="item.id">{{item.xAxisValueData}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        
        </ion-row>
    
        <ion-row>
          <ion-col size="12" *ngIf="isElcmTypetable4">
            <div id="table-scroll">
              <table id="graph5-table-data">
                <tr>
                  <th>Department</th>
                  <th>Probation</th>
                  <th>Confirmation</th>
                  <th>Extension</th>
                </tr>
                <tr *ngFor="let item of departmentDataForFourthGraph">
                  <td class="fs-14 fs_12ForMobile font_semibold">{{item.xAxisValueData}}</td>
                  <td>{{item.seriesValueOneData}}</td>
                  <td>{{item.seriesValueTwoData}}</td>
                  <td>{{item.seriesValueThreeData}}</td>
                </tr>
              </table>
            </div>
          </ion-col>
    
          <ion-col size="12" *ngIf="!isElcmTypetable4">
            <!-- <div id="fourth-elcm-chart" style="width: 100%; height: 400px;"></div> -->
            <div [ngClass]="{'dispNone' : departmentDataForFourthGraph}" id="fourth-elcm-chart"
            [ngStyle]="chartStyle"></div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
    



    <!-- ---------------------------------------------------------------Termination----------------------------------------------- -->


    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="graphs">
        <ion-row>
          <ion-col size="12" size-md="8">
            <div class="font_bold fs-16 fs_14ForMobile" *ngIf="['Hr Admin','Super Admin','PHI Admin','MD'].includes(loggedInUserRole)" >Total Exited Vs Resigned Vs Terminated</div>
            <div class="font_bold fs-16 fs_14ForMobile" *ngIf="!['Hr Admin','Super Admin','PHI Admin','MD'].includes(loggedInUserRole)" >Total Exited Vs Resigned</div>
          </ion-col>
          <ion-col size="12" size-md="4">
            <div class="phi-flex-wrap-center phi-gap-10 phi-justify-content-end phi-align-items-center">
            <!-- <ion-row class="icon-group">
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeGraphExit('bar')">
                  <img *ngIf="isElcmTypeIconExit != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIconExit == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeTableExit()">
                  <img *ngIf="!isElcmTypetableExit" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypetableExit" src="././assets/icon/TableIconActive.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto"> -->
                <span (click)="switchElcmTypeGraphExit('line')">
                  <img *ngIf="isElcmTypeIconExit != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                  <img *ngIf="isElcmTypeIconExit == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                </span>
              <!-- </ion-col>
              <ion-col size="auto" class="cp"> -->
                <img   (click)="downloadChartAsPDF('Total Exited Vs Resigned Vs Terminated')"src="././assets/icon/downloadIcon.svg">
              <!-- </ion-col>
            </ion-row> -->
            </div>
          </ion-col>
        </ion-row>
        
    
        <ion-row>

       
        <ion-col size="12" size-md="4" size-lg="2" style="margin-top: -17px;">
          <ng-multiselect-dropdown
          class="ml-5 w250 mat-height40 fs-10"
     
          [placeholder]="'Select Dept'"
          [settings]="dropdownSettings"
          [data]="dropDownForExit"
          [(ngModel)]="selectedDepartment"
          (onSelect)="onSelectDepartment()"
          (onDeSelect)="onDeSelectDepartment()"
          (onSelectAll)="selectAllDepartment($event)"
          (onDeSelectAll)="onDeSelectAllDepartment()"
        >
        </ng-multiselect-dropdown>
        </ion-col>
        <ion-col size="12" size-md="4" size-lg="2">
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedYeargraph6"
              (selectionChange)="onClickYtdYear($event,'Year','graph6')">
              <mat-option [value]="item.year"
                *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
        <ion-col size="12" size-md="4" size-lg="2">
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Month" [(ngModel)]="terminationMonth"
              (selectionChange)="onClickYtdYear($event,'Month','graph6')">
              <mat-option [value]="item.number"
                *ngFor="let item of getMonthsList">{{sharedService.transform(item.name)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
        </ion-row>
    
        <ion-row>
          <ion-col size="12" *ngIf="isElcmTypetableExit">
            <div id="table-scroll">
              <table id="exit-table-data">
                <tr>
                  <th>Department</th>
                  <th>Resigned</th>
                  <th>Exited</th>
                  <th>Terminated</th>
                </tr>
                <tr *ngFor="let item of exitGraphTableDate">
                  <td class="fs-14 fs_12ForMobile font_semibold">{{item.xAxisValueData}}</td>
                  <td>{{item.seriesValueOneData}}</td>
                  <td>{{item.seriesValueTwoData}}</td>
                  <td>{{item.seriesValueThreeData}}</td>
                </tr>
              </table>
            </div>
          </ion-col>
    
          <ion-col size="12" *ngIf="!isElcmTypetableExit">
            <!-- <div id="fourth-elcm-chart" style="width: 100%; height: 400px;"></div> -->
            <div [ngClass]="{'dispNone' : departmentDataForFourthGraph}" id="exit-elcm-chart"
         [ngStyle]="chartStyle" ></div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>


</div>